import React from 'react';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ServicesSection } from './components/ServicesSection';
import { GallerySection } from './components/GallerySection';
import { BenefitsSection } from './components/BenefitsSection';
import { ProcessSection } from './components/ProcessSection';
import { CourseSection } from './components/CourseSection';
import { TrustSection } from './components/TrustSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { LocationSection } from './components/LocationSection';
import { BookingToast } from './components/BookingToast';
import { LanguageProvider, useLanguage } from './components/LanguageContext';
import { LanguageSelector } from './components/LanguageSelector';
import { LanguageToggle } from './components/LanguageToggle';
function MainApp() {
  const {
    t
  } = useLanguage();
  return <div className="w-full min-h-screen bg-[var(--warm-cream)] font-sans text-[var(--text-dark)] overflow-x-hidden animate-fade-in" data-id="element-0">
      <LanguageToggle data-id="element-1" />
      <BookingToast data-id="element-2" />
      <HeroSection data-id="element-3" />
      <AboutSection data-id="element-4" />
      <ServicesSection data-id="element-5" />
      <GallerySection data-id="element-6" />
      <BenefitsSection data-id="element-7" />
      <ProcessSection data-id="element-8" />
      <CourseSection data-id="element-9" />
      <TrustSection data-id="element-10" />
      <TestimonialsSection data-id="element-11" />
      <LocationSection data-id="element-12" />

      {/* Simple Footer */}
      <footer className="w-full py-8 bg-[#2C1810] text-center border-t border-white/10" data-id="element-13">
        <p className="text-white/50 text-sm font-light" data-id="element-14">{t('footer_text')}</p>
      </footer>
    </div>;
}
export function App() {
  return <LanguageProvider data-id="element-15">
      <LanguageSelector data-id="element-16" />
      <MainApp data-id="element-17" />
    </LanguageProvider>;
}